import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import i18n from '@locales/i18n';
import { IntroductionEn } from './IntroductionEn';
import { IntroductionKo } from './IntroductionKo';
import * as S from './IntroductionKoStyles';

export const Introduction = () => {
  const [language, setLanguage] = useState(i18n.language);
  const navigate = useNavigate();
  const { providerDomain } = useParams<{ providerDomain?: string }>();

  const handleInquiryClick = useCallback(() => {
    const path = providerDomain
      ? `/stores/${providerDomain}/tenant-request`
      : '/tenant-request';
    navigate(path);
  }, [navigate, providerDomain]);

  useEffect(() => {
    const updateLanguage = () => {
      setLanguage(i18n.language);
    };

    i18n.on('languageChanged', updateLanguage);

    return () => {
      i18n.off('languageChanged', updateLanguage);
    };
  }, []);

  return (
    <S.Container className="container">
      {language === 'ko' ? (
        <IntroductionKo onInquiryClick={handleInquiryClick} />
      ) : (
        <IntroductionEn onInquiryClick={handleInquiryClick} />
      )}
    </S.Container>
  );
};
